export const download = {
  accessButton: "Acessar",
  downloadButton: "Baixar",
  webDesc: "Acesse o site no seu navegador",
  windowsDesc: "Baixe o instalador para Windows",
  linuxDesc: "Baixe o instalador para Linux",
  androidDesc: "Baixe o APK para Android",
  iosDesc: "Baixe o app para iOS",
  title: "Baixe o app",
  subtitle:
    "Acesse Araria em qualquer lugar, no seu navegador, computador ou em seu smartphone",
};
